import fightingGameImage from '../images/projects/fighting-game.png';
import truckDataImage from '../images/projects/truck-data.png';

const projects = [
  {
    title: 'Fighting Game',
    imagePreview: fightingGameImage,
    deployedUrl: 'https://tuinderj.github.io/fighting-game/',
    repoUrl: 'https://github.com/TuinderJ/fighting-game',
  },
  {
    title: 'Truck Data',
    imagePreview: truckDataImage,
    deployedUrl: 'https://tuinderj.github.io/personal-website/truck-data',
    repoUrl: 'https://github.com/TuinderJ/personal-website/tree/main/truck-data',
  },
];

export default projects;
